'use strict';

export default function f($timeout, unreadConversationIds) {
  'ngInject';

  return {
    title: document.title,
    notificationTitle: '',
    notifyTitle() {
      this.notificationTitle = `(${unreadConversationIds.getIds().length}) ${this.title}`;
      clearInterval(this.interval);
      document.title = this.notificationTitle;
    },

    readTitle() {
      document.title = this.title;
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/title.js